'use client';

import FadeIn from '../ui/FadeIn';
import { useTranslations } from '@/lib/i18n/TranslationProvider';

export default function HowToExport() {
    const { t } = useTranslations();
    const steps = t.howToExport.steps;

    return (
        <section className="section-padding bg-[var(--color-md-surface)] border-t border-[var(--color-md-outline-variant)]">
            <div className="container mx-auto px-6">
                <FadeIn className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-black text-[var(--color-md-on-surface)] tracking-tight mb-6">
                        {t.howToExport.title}<br className="hidden md:block" /> {t.howToExport.titleBreak}
                    </h2>
                </FadeIn>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                    {steps.map((step, i) => (
                        <FadeIn key={i} delay={i * 0.1} yOffset={20} className="relative">
                            <div className="p-8 rounded-3xl bg-[var(--color-md-surface-variant)] border border-[var(--color-md-outline)] h-full relative overflow-hidden group hover:border-[var(--color-md-primary)]/30 transition-colors duration-300">
                                <div className="absolute top-0 right-0 p-6 text-6xl font-black text-[var(--color-md-primary)] opacity-10 group-hover:opacity-20 transition-opacity">
                                    {step.num}
                                </div>
                                <h3 className="text-xl font-bold text-[var(--color-md-on-surface)] mb-3 relative z-10">
                                    {step.title}
                                </h3>
                                <p className="text-[var(--color-md-on-surface-variant)] leading-relaxed relative z-10">
                                    {step.desc}
                                </p>
                            </div>
                        </FadeIn>
                    ))}
                </div>
            </div>
        </section>
    );
}
